import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { siteTitle } from "../_index";
import References from "../features/References";
import { Services } from "../features/Services";
import Slogans from "../features/Slogans";
import ContactForm from "./features/Form";
import { servicesData } from "./features/hizmetlerData";

export const HizmetSubTitle = "Başarının gelecekte yattığını bilerek, teknolojiyi yakından takip ediyor ve üretici firmalarla güçlü ortaklıklar kuruyoruz. Sektördeki tüm yenilikleri ve değişimleri izleyerek, iş ortaklarımız için hem ihracatta hem ithalatta kapsamlı pazar araştırmalar yapıp müşteri bilgileri sağlayabiliyor, muhtelif konularda yapılan eğitimler ile iş ortaklarımızın gelişimine yardımcı oluyoruz.";
export const loader = () => {
  const title = HizmetSubTitle.replaceAll('ş', '<i>&#351;</i>').replaceAll('Ş', '<i>&#350;</i>').replaceAll('ğ', '<i>&#287;</i>').replaceAll('Ğ', '<i>&#286;</i>');
  return { servicesData, title };
};
export const meta = () => {
  return [{
    title: `Hizmetlerimiz | Hizmetler | UTB Trader & Support | UTB Support Hizmetleri | ${siteTitle}`,
  }]
}
export default function Page() {
  const { servicesData, title } = useLoaderData<typeof loader>();
  return (
    <div className="pt-[122px]">
      <div className="bg-[#f5f5f5] [&_#hizmetlerimiz_h2]:hidden [&>div>#hizmetlerimiz>div>p]:hidden">
        <div className="header bg-[#efefef]">
          <Container>
            <h1 className="font-raleway uppercase text-[28px] py-12 w-full font-bold">Hizmetlerimiz</h1>
          </Container>
        </div>
        <Container className="flex-wrap">
          <p className="text-center text-[24px] mb-12 font-lato font-light text-[#444444] relative font-[300] py-12 after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:m-auto after:w-20 after:h-0.5 after:bg-[#20b1d7] [&_i]:font-thin [&_i]:not-italic [&_i]:font-lato" dangerouslySetInnerHTML={{ __html: title }} />
          <Services hizmetler={servicesData} />
          <ContactForm services={servicesData} />
        </Container>
      </div>
      <Slogans />
      <References />
    </div>
  )
}
